export const GET_ANALITICS_SUCCESS = 'GET_ANALITICS_SUCCESS';
export const GET_ANALITICS_ERROR = 'GET_ANALITICS_ERROR';
export const GET_ANALITICS_LOADING = 'GET_ANALITICS_LOADING';
